export default {
  'Network Error': 'SOMETHING_WENT_WRONG',
  SECURITY_CONTEXT_NULL: 'SECURITY_CONTEXT_NULL',
  INVALID_API_USERNAME: 'INVALID_API_USERNAME',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
  SUBJECT_NOT_EXIST: 'SUBJECT_NOT_EXIST',
  SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
  OWN_API_USERNAME: 'OWN_API_USERNAME',
}
